import { JobData } from '../api/JobsService';
import { JobDetails } from '../types/job';

/**
 * Extracts skills from the requirements HTML string in job data
 * @param requirements HTML string containing job requirements
 * @returns Array of extracted skills
 */
export const extractSkillsFromRequirements = (requirements: string): string[] => {
  if (!requirements || !requirements.trim()) {
    return [];
  }

  // Extract list items from HTML
  const requirementsMatch = requirements.match(/<li>(.*?)<\/li>/g);
  if (requirementsMatch) {
    // Extract text from li elements
    return requirementsMatch.map(item => 
      item.replace(/<li>(.*?)<\/li>/, '$1').replace(/<[^>]*>/g, '')
    );
  }

  return [];
};

/**
 * Converts API job data to the format expected by the application UI
 * @param job Job data from the API
 * @returns Formatted job details for display
 */
export const transformJobToDetails = (job: JobData): JobDetails => {
  //const requiredSkills = extractSkillsFromRequirements(job.requirements || '');
  const requiredSkills = job.requirements || '';
  
  return {
    title: job.title,
    location: job.locations && job.locations.length > 0 
      ? `${job.locations[0].city}, ${job.locations[0].region}` 
      : 'Location not specified',
    function: job.jobFunction || 'Not specified',
    industry: job.industry || 'Not specified',
    companyName: job.companyName || 'Not specified',
    hostedApplyUrl: job.applyUrl,
    contactEmail: job.contactEmail || 'Not specified',
    description: job.description,
    requiredSkills
  };
};

/**
 * Filters jobs to return only "Open" and "Pending" jobs
 * @param jobs Array of job data from API
 * @returns Array of only "Open" and "Pending" jobs
 */
export const filterClosedJobs = (jobs: JobData[]): JobData[] => {
  return jobs.filter((job) => job.status !== 'Closed');
};

export default {
  extractSkillsFromRequirements,
  transformJobToDetails,
  filterClosedJobs
}; 